<!--
 * @Description: 当前专区下的内容分类：首页、搜索页
 * @Date: 2021-02-02 15:25:59
-->
<template>
  <div v-show="firstList.length" class="category-tab">
    <van-tabs
      :class="[
        'category-tab__first',
        secondList.length ? 'category-tab__first--has-second' : ''
      ]"
      v-model="firstActive"
      :swipe-threshold="1"
      :ellipsis="false"
    >
      <van-tab v-for="(item, index) in firstList" :key="index" :title="item.moduleName"></van-tab>
    </van-tabs>
    <van-tabs
      class="category-tab__second"
      v-show="~firstActive && secondList.length"
      v-model="secondActive"
      :swipe-threshold="1"
      :ellipsis="false"
    >
      <van-tab v-for="(item, index) in secondList" :key="index" :title="item.moduleName"></van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { channelMenuList } from '@/api/home';
import { querychannelCourseMenuInfo } from '@/api/course';

export default {
  name: 'CategoryTab',
  props: {
    useInit: {
      type: Number,
      default: 0
    },
    // 搜索
    keyword: ''
  },
  data() {
    return {
      firstList: [],
      secondList: [],
      firstActive: -1,
      secondActive: -1
    };
  },
  components: {},
  watch: {
    firstActive(v) {
      this.setFirstActive(v);
    },
    secondActive(v) {
      this.setSecondActive(v);
    },
    useInit() {
      this.setList();
    }
  },
  computed: {},
  methods: {
    async setList() {
      let { pdata } = await channelMenuList();
      this.firstList = pdata || [];
      this.firstList.length && (this.firstActive = 0);
      if (this.keyword) {
        this.getSearchId2Index();
      }
    },
    // 获取搜索有数据的菜单id
    async getSearchId2Index() {
      let {
        pdata: { firstId, secondId }
      } = await querychannelCourseMenuInfo({
        searchName: this.keyword
      });

      let first = {};
      this.firstList.forEach((item, index) => {
        if (+item.id == firstId) {
          first = { ...item, index };
        }
      });
      this.firstActive = first.index;
      if (secondId) {
        setTimeout(() => {
          this.secondActive = first.menus.findIndex(
            item => item.id == secondId
          );
        }, 100);
      }
    },
    setFirstActive(v, activeLocation = false) {
      let secondList = (this.secondList = this.firstList[v].menus || []);
      this.secondActive = -1;
      // 只有一级
      if (!secondList.length) {
        this.$emit('change', this.firstList[v]);
      } else {
        setTimeout(() => {
          this.secondActive = 0;
        });
      }
    },
    setSecondActive(v) {
      if (~v && this.secondList.length) {
        this.$emit('change', this.secondList[v]);
      }
    }
  },
  async created() {
    this.setList();
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.category-tab {
  &__first {
    .van-tabs__wrap {
      height: 1rem;
    }
    .van-tabs__nav {
      padding-bottom: 0;
    }
    .van-tabs__line {
      display: none;
    }
    .van-tab__text {
      font-size: 0.37rem;
      color: #666666;
      font-weight: 400;
    }
    .van-tab {
      // padding-bottom: .13rem
    }
    .van-tab--active {
      position: relative;

      .van-tab__text {
        font-size: 0.48rem !important;
        color: #000 !important;
        font-weight: 500 !important;
      }
    }
    &--has-second {
      .van-tab--active {
        &::after {
          content: ' ';
          width: 0;
          height: 0;
          border-bottom: 0.27rem solid rgba(107, 117, 139, 0.19);
          border-right: 0.27rem solid transparent;
          border-left: 0.27rem solid transparent;
          position: absolute;
          bottom: -0.1rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  &__second {
    padding: 0 0.33rem;
    // margin-top: 0.2rem;
    height: 0.91rem;
    @extend .category-tab__first;
    .van-tab__text {
      font-size: 0.32rem !important;
    }
    .van-tabs__wrap {
      height: 0.99rem;
      box-shadow: -0.01rem -0.01rem 0.18rem 0px rgba(107, 117, 139, 0.19);
    }
    .van-tabs__nav {
      background: #ededed;
    }
    .van-tabs__line {
      display: block;
      bottom: 1px;
    }
    .van-tab--active {
      &::after {
        display: none;
      }
      .van-tab__text {
        font-size: 0.37rem !important;
        font-weight: 400 !important;
      }
    }
  }
}
</style>
